/**
 * Blob 을 파일로 다운로드합니다.
 *
 * @param blob - 다운로드할 Blob (서버에서 받은 CSV, 클라이언트에서 만든 샘플 등)
 * @param fileName - 확장자를 포함한 파일명
 *
 * @example
 * ```ts
 * // 엑셀 호환을 위해 CSV 앞에는 UTF-8 BOM(U+FEFF)을 붙여서 넘긴다
 * downloadBlobFile(new Blob(['\uFEFF' + csv], { type: 'text/csv' }), 'sample.csv');
 * ```
 *
 * @remarks
 * 기존 `downloadExcel` 은 xlsx 전용이고 createObjectURL 로 만든 URL 을 해제하지 않아
 * 페이지가 살아있는 동안 메모리에 남는다. 이 함수는 클릭 직후 revokeObjectURL 로 해제한다.
 */
export const downloadBlobFile = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // 클릭과 같은 tick 에 revoke 하면 Safari 등 일부 엔진에서 큰 blob 의 다운로드가
  // 시작되기 전에 URL 이 무효화될 수 있어 한 박자 늦춰 해제한다
  window.setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 1000);
};
